import { AxiosPromise } from 'axios';
import axios from 'axios';

const uri = '/mgmt/board/notice/img';

export const uploadImage = (data: FormData): AxiosPromise => {
  return axios.post(uri, data);
};
